import React, { Fragment, useCallback } from 'react';
import classnames from 'classnames';
import Radio from './Radio';
import Context from './context';
import { ConfigContext } from '../config-provider';
import useMergedState from '../_util/hooks/useMergedState';
export default (props) => {
    const { prefixCls: customizePrefixCls, disabled = false, optionType = 'default', options, children, className, enhance = false, onChange } = props;
    const [value, setValue] = useMergedState(props.defaultValue, {
        value: props.value
    });
    const handleClick = useCallback(e => {
        const newValue = e.target.value;
        if (disabled) {
            return;
        }
        setValue(newValue);
        if (onChange && value !== newValue) {
            onChange(e);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value, disabled, onChange]);
    const Compo = optionType === 'default' ? Radio : Radio.Button;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('radio-group', customizePrefixCls);
    const enhancePrefixCls = getPrefixCls('radio-group-enhance', customizePrefixCls);
    const classNames = classnames(prefixCls, { [enhancePrefixCls]: enhance }, className);
    return (<Fragment>
            <div className={classNames}>
                <Context.Provider value={{
            value,
            disabled,
            onChange: handleClick
        }}>
                    {!options
            ? children
            : options.map((option, index) => <Compo key={option.value || index} {...option}/>)}
                </Context.Provider>
            </div>
        </Fragment>);
};
